import _ from 'lodash'
import fetch from '@adc/fetch'

export const authenticateUser = (email, password) => {
  // Signal to core-utils session.create that this login will be used in a
  // cross-site iframe (e.g. Salesforce). Triggers SameSite=None on auth cookies.
  const headers = {}
  if (window.location.pathname.startsWith('/embed/')) {
    headers['x-auction-authentication-enabled-frame'] = '1'
  }

  return fetch
    .fromService('URL_BASE_PREFIX')
    .post('/xhr/login/', {
      headers,
      body: { email, password },
    })
    .then(({ body: user }) => {
      const authorities = _.get(user, 'authorities', [])

      // TODO: Move this to the backend implementation, to avoid returning a success from the server, setting the cookie,
      // but then failing here.
      const hasAuthority =
        authorities.includes('ML') || authorities.includes('MRP_LOGIN')

      // We want to emulate an invalid username/password so we throw same as API
      if (!hasAuthority) {
        const error = { error_code: 'ERR_INVALID_GRANT' }
        throw error
      }

      return {
        ...user,
        logged_in: true,
      }
    })
}
